import findIndex from 'lodash/findIndex'
import {generateRules, sortProductColors} from './colors'

export const filterAndSortProductOptions = function (
  store,
  options,
  Colors = []
) {
  const {
    ProductColors = {IncludedList: [], ExcludedList: []},
    SchoolColor1: color1,
    SchoolColor2: color2,
    SchoolColor3: color3
  } = store

  const colors = [
    color1 && color1.ColorHexCode,
    color2 && color2.ColorHexCode,
    color3 && color3.ColorHexCode
  ].filter((c) => c)

  // Limit options based on school product color lists
  const whiteList = new Set(
    ProductColors.IncludedList.map((c) => c.toLowerCase())
  )
  const blackList = new Set(
    ProductColors.ExcludedList.map((c) => c.toLowerCase())
  )

  let filteredOptions = options.slice()

  if (whiteList.size || blackList.size) {
    // Add neutrals to white list unless they are black listed
    const neutrals = ['white', 'gray', 'grey', 'black']
    neutrals.forEach((c) => !blackList.has(c) && whiteList.add(c))

    // Always add school colors
    color1 && whiteList.add(color1.ColorName.toLowerCase())
    color2 && whiteList.add(color2.ColorName.toLowerCase())
    color3 && whiteList.add(color3.ColorName.toLowerCase())

    filteredOptions = filteredOptions.filter((po) => {
      let {Color, MainColor, MainColorPantone} = po
      Color = Color.toLowerCase()
      MainColor = MainColor.toLowerCase()
      MainColorPantone = (MainColorPantone || '').toLowerCase()

      if (
        blackList.has(Color) ||
        blackList.has(MainColor) ||
        blackList.has(MainColorPantone)
      ) {
        return false
      }

      return (
        !whiteList.size ||
        whiteList.has(Color) ||
        whiteList.has(MainColor) ||
        whiteList.has(MainColorPantone)
      )
    })
  }

  // Limit colors to list provided by Prep.
  // TODO(wes): Replace this by using DesignColorRules table
  if (Colors.length) {
    const colorsSet = new Set(Colors.map((c) => c.NName.toLowerCase()))
    filteredOptions = filteredOptions.filter((po) =>
      colorsSet.has(po.SanitizedColorName)
    )
  }

  const sortedColors = sortProductColors(
    filteredOptions.map((po) => po.ColorValue.ColorHexCode.toLowerCase()),
    colors
  )

  let sortedProductOptions = filteredOptions.slice()
  sortedProductOptions = sortedColors.map((c) => {
    const index = findIndex(
      sortedProductOptions,
      (po) => po.ColorValue.ColorHexCode.toLowerCase() === c.toLowerCase()
    )

    // Note that we remove options one by one since more than one option can
    // have the same color hex value.
    const option = sortedProductOptions[index]
    sortedProductOptions.splice(index, 1)

    return option
  })

  // Make sure we always return something... anything
  return sortedProductOptions.length ? sortedProductOptions : [options[0]]
}

export const generateProductColorRules = function (store, products) {
  const {
    SchoolColor1: color1,
    SchoolColor2: color2,
    SchoolColor3: color3
  } = store

  const storeColors = [
    color1 && color1.ColorHexCode,
    color2 && color2.ColorHexCode,
    color3 && color3.ColorHexCode
  ].filter((c) => c)

  products.forEach((p) => {
    const [rule] = storeColors.length
      ? generateRules(p.ProductColorHexCode, storeColors, p.Design)
      : []

    p.rule = rule
  })

  return products
}

export const parseCategoryRestrictions = (str) => {
  const result = {include: [], exclude: []}
  let appendTo = result.include
  if (!str) {
    return result
  }

  str.split(',').forEach((cat) => {
    if (cat.startsWith('-')) {
      appendTo = result.exclude
      cat = cat.slice(1)
    } else if (cat.startsWith('+')) {
      appendTo = result.include
      cat = cat.slice(1)
    }

    appendTo.push(parseInt(cat, 10))
  })

  return result
}

export const serializeCategoryRestrictions = (obj) => {
  const {include = [], exclude = []} = obj

  const result = []
  if (include.length) {
    result.push(`+${include.join(',')}`)
  }

  if (exclude.length) {
    result.push(`-${exclude.join(',')}`)
  }

  return result.join(',')
}
